$(".faq-item__question").on("click", function() {
	const $this = $(this);
	const $content = $this.next();

	$content.stop(true, false).slideToggle();
	$this.parent().toggleClass("faq-item--active");

	$(".faq-item__question")
		.not($this)
		.each(function() {
			const $otherContent = $(this).next();
			$otherContent.stop(true, true).slideUp();
			$(this)
				.parent()
				.removeClass("faq-item--active");
		});
});



// WEBPACK FOOTER //
// ./scripts/modules/faq.js